/* eslint-disable no-underscore-dangle */
import axios from '../../utils/axios';
import config from '../../config/index.json';
import { encode } from '../../utils/encode';
import store from '../../redux/store';
import getHeader from '../../utils/header';
import { getUserLocale, sanitizePhoneInput, validatePhoneForSubmission } from '../../utils/common';
import { DVA_ORDER_TYPE } from '../../constants/dvacreditclaim.const';
import { RETURN_CENTER_ADDRESS_KEY } from '../../constants/returns.const';

export const getBillingAddress = async (type, account) => {
  const { cartDetails, authentication } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const apQualifier = authentication?.user?._accounts[0]?._element[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  try {
    const resp = await axios.get(`${config.api.path}/addresses/${localStorage.getItem('StoreName')}/billing?zoom=element`, {

      headers: getHeader({ functionName: 'shippingInformation.getBillingAddress', values: [type ? `ORDER_TYPE=${orderTypeData},GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : ''] }),

    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getShippingAddress = async (account, type, historyType, shipToAccount) => {
  const { cartDetails, authentication } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const apQualifier = authentication?.user?._accounts[0]?._element[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  const shipToAccountHeader = (historyType === 'RETURNS_HISTORY' && shipToAccount) ?`,SHIP_TO_ACCOUNT = ${shipToAccount}`:''  
  const isNewAddressApi = Boolean(authentication?.isCustomShippingAddressEnabled);

  let filteredResponse;
  try {
    const resp = await axios.get(isNewAddressApi ? `${config.api.path}/extaddresses/${localStorage.getItem('StoreName')}/customer-shipping-addresses` : `${config.api.path}/addresses/${localStorage.getItem('StoreName')}/shipping?zoom=element`, {
      headers: getHeader({ functionName: 'shippingInformation.getShippingAddress', values: [(account || localStorage.getItem('defaultUserID')), (historyType || orderTypeData || 'Standard'), (historyType ? `ORDER_TYPE=${historyType}${shipToAccountHeader}` : type ? `ORDER_TYPE=${orderTypeData}${shipToAccountHeader},GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : '')] }),
    });
    if (isNewAddressApi) {
      filteredResponse = resp?.data?.addresses?.map((respFlag) => {
        return {address: respFlag?.address, self: {uri : respFlag?.address?.uri}}
      }) || [];
    } else {
      filteredResponse = resp?.data?._element?.map((res) => {
        return {address: res?.address, self: {uri : res?.self?.uri}}
      }) || [];
    }
    return filteredResponse;
  } catch (err) {
    throw err.message;
  }
};

export const getContactAddress = async (account, type, historyType) => {
  const { cartDetails, authentication } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const apQualifier = authentication?.user?._accounts[0]?._element[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  try {
    const resp = await axios.get(`${config.api.path}/extrmacontactsapi/${localStorage.getItem('StoreName')}/customernumber/${encode(account)}`, {
      headers: getHeader({ functionName: 'shippingInformation.getContactAddress', values: [account || localStorage.getItem('defaultUserID'), historyType || orderTypeData || 'Standard', historyType ? `ORDER_TYPE=${historyType}` : type ? `ORDER_TYPE=${orderTypeData},GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : ''] }),
      noLoader: true,
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const callSetdefaultShipping = async (endpoint, address, type, pageName) => {
  const { cartDetails, authentication } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const apQualifier = authentication?.user?._accounts[0]?._element[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  try {
    const resp = await axios.post(`${config.api.path}${endpoint}/selector${address}`, {}, {
      headers: getHeader({ functionName: 'shippingInformation.callSetdefaultShipping', values: [type ? `ORDER_TYPE=${orderTypeData},GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : pageName === 'RETURNS' ? `ORDER_TYPE=${pageName}` : ''] }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const submitDropShip = async (dropShipAddress, type) => {
  const { cartDetails, authentication } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const apQualifier = authentication?.user?._accounts[0]?._element[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  try {
    const resp = await axios.post(`${config.api.path}/addresses/${localStorage.getItem('StoreName')}/form?followlocation`, dropShipAddress, {
      headers: getHeader({ functionName: 'shippingInformation.submitDropShip', values: [type ? `ORDER_TYPE=${orderTypeData},GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : ''] }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};


export const callSetdefaultBilling = async (orderId, address, type, pageName, selectedBillTo = '') => {
  const { cartDetails, authentication } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const apQualifier = authentication?.user?._accounts[0]?._element[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  try {
    const resp = await axios.post(`${config.api.path}${orderId}/billingaddressinfo/selector${address}`, {}, {
      headers: getHeader({ functionName: 'shippingInformation.callSetdefaultBilling', values: [type ? `ORDER_TYPE=${orderTypeData},GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : pageName === 'RETURNS' ? `ORDER_TYPE=${pageName}${selectedBillTo ? `,BILL_TO_ACCOUNT=${selectedBillTo}` : ''}` : pageName === 'MaskGuarentee' ? 'ORDER_TYPE=MASKGUARANTEE,GEOIP_FIRST_LEVEL_DOMAIN=MASKGUARANTEE' : ''] }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const setDefaultcontactInfo = async (values) => {
  const body = {
    email: values.emailAddress,
    'first-name': values.firstName,
    'last-name': values.lastName,
    phone: validatePhoneForSubmission(sanitizePhoneInput(values.phoneNumber), { required: true, fieldName: 'phone' }),
    fax: values.fax,
  };
  try {
    const resp = await axios.post(`${config.api.path}/emails/${localStorage.getItem('StoreName')}/form`, body, {
      headers: getHeader({ functionName: 'shippingInformation.setDefaultcontactInfo' }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getOrderId = async (pageName, isPayment) => {
  const { cartDetails, authentication, setUser } = store.getState();
  const qualifier = authentication?.user?._accounts[0]?._element?.filter(a => a?.AP_ACCOUNT_NUMBER === setUser?.accountNumber);
  const apQualifier = qualifier[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  let typeOrder;
  switch (pageName) {
    case 'placeOrder':
      typeOrder = cartDetails.orderType;
      break;
    case 'maskGuarantee':
      typeOrder = 'MASKGUARANTEE';
      break;
    case 'RETURNS':
      typeOrder = 'RETURNS';
      break;
    case 'cto':
      typeOrder = cartDetails.orderType;
      break;
    default:
      typeOrder = '';
  }
  try {
    const resp = await axios.get(`${config.api.path}?zoom=defaultcart:order${pageName ? `${isPayment ? ',defaultcart:order:purchaseform' : ',defaultcart:order:paymentmethodinfo:element:paymentinstrumentform,defaultcart:order:purchaseform'}` : ''}${pageName && (pageName === 'maskGuarantee' || pageName === 'cto') ? ',defaultcart:order:deliveries:element:destinationinfo:selector' : '&format=standardlinks,zoom.nodatalinks'}`, {
      headers: getHeader({ functionName: 'shippingInformation.getOrderId', values: [pageName ? `ORDER_TYPE=${typeOrder},GEOIP_FIRST_LEVEL_DOMAIN=${typeOrder},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : ''] }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getShippingMethod = async (cartId) => {
  const { cartDetails, authentication, setUser } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const qualifier = authentication?.user?._accounts[0]?._element.filter(a => a.AP_ACCOUNT_NUMBER === setUser?.accountNumber);
  const apQualifier = qualifier?.[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  try {
    const resp = await axios.get(`${config.api.path}${cartId}?zoom=deliveries:element:shippingoptioninfo:selector:choice,deliveries:element:shippingoptioninfo:selector:choice:description,deliveries:element:shippingoptioninfo:selector:chosen,deliveries:element:shippingoptioninfo:selector:chosen:description&format=standardlinks,zoom.nodatalinks`, {
      headers: getHeader({ functionName: 'shippingInformation.getShippingMethod', values: [`ORDER_TYPE=${orderTypeData},GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}`] }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getShippingNewMethod = async (page) => {
  const { cartDetails, authentication, setUser } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const qualifier = authentication?.user?._accounts[0]?._element?.filter(a => a.AP_ACCOUNT_NUMBER === setUser?.accountNumber);
  const apQualifier = qualifier?.[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  const shipState = cartDetails?.shipToSiteAddressState;
  // API expects a single space to represent an empty ship-to state.
  const EMPTY_SHIP_STATE_SENTINEL = ' ';
  const shipStateValue =
  (!shipState || String(shipState).trim() === '')
      ? EMPTY_SHIP_STATE_SENTINEL
      : shipState;
  const shipToStateParam = page ? `SHIP_TO_SITE_ADDRESS_STATE=${shipStateValue}` : '';
  try {
    const encodeParam = `USER_ID=${authentication.user.email};ORG_ID=${authentication.user?.CP_ORGID};COUNTRY=${authentication.user?.CP_COUNTRY};${shipToStateParam}`;
    const resp = await axios.get(`${config.api.path}/usershipmethods/resmed_us/details/${encode(encodeParam)}`, {
      headers: getHeader({ functionName: 'shippingInformation.getShippingNewMethod', values: [`ORDER_TYPE=${orderTypeData},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}`] }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};


export const callSetDefaultShippingMethod = async (endPoint, value) => {
  if (!value) return;
  const { cartDetails, authentication, setUser } = store.getState();
  const orderTypeData = cartDetails?.orderType;
  const qualifier = authentication?.user?._accounts[0]._element.filter(a => a.AP_ACCOUNT_NUMBER === setUser?.accountNumber);
  const apQualifier = qualifier?.[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  try {
    const resp = await axios.post(`${endPoint}/${encode(value)}`, {}, {
      headers: getHeader({ functionName: 'shippingInformation.callSetDefaultShippingMethod', values: [`ORDER_TYPE=${orderTypeData},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}`] }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};


export const setDefaultShippingForAccount = async (type, shipAddress, noDefault, orderType, axiosConfig = {}) => {
  const { cartDetails, authentication, setUser } = store.getState();
  const orderTypeData = cartDetails.orderType ? cartDetails.orderType : orderType || null;
  const qualifier = authentication.user._accounts[0]._element.filter(a => a.AP_ACCOUNT_NUMBER === setUser.accountNumber);
  const apQualifier = qualifier[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  const postData = {
    'shipping-address-id': shipAddress.split('/')[3],
    'is-default': !!noDefault,
  };
  try {
    const resp = await axios.post(`${config.api.path}/rosdefaultaddress/${localStorage.getItem('StoreName')}/form?followlocation`, postData, {
      headers: getHeader({ functionName: 'shippingInformation.setDefaultShippingForAccount', values: [type ? `ORDER_TYPE=${orderTypeData},SELECTED_STATE=${cartDetails.shipToSiteAddressState},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${cartDetails.shipToSiteAddressID ? cartDetails.shipToSiteAddressID : 0},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : ''] }),
      ...axiosConfig,
    });
    localStorage.setItem('customerDefaultCurrency', resp.data?.['customer-default-currency'] ? resp.data?.['customer-default-currency'] : '');
    return resp;
  } catch (err) {
    throw err.message;
  }
};


export const getDefaultShippingForAccount = async (type, orderType, shipToSiteAddressId = 0) => {
  const { cartDetails, authentication, setUser } = store.getState();
  const orderTypeData = cartDetails.orderType || null;
  const qualifier = authentication.user._accounts[0]._element.filter(a => a.AP_ACCOUNT_NUMBER === setUser.accountNumber);
  const apQualifier = qualifier[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = cartDetails?.priceListId ? cartDetails?.priceListId : '';
  const shipToSiteId = (orderType === DVA_ORDER_TYPE ? shipToSiteAddressId : cartDetails?.shipToSiteAddressID) || 0;
  try {
    const resp = await axios.get(`${config.api.path}/rosdefaultaddress/${localStorage.getItem('StoreName')}/info`, {
      headers: type ?
        getHeader({ functionName: 'shippingInformation.getDefaultShippingForAccount', values: [type ? `ORDER_TYPE=${orderType || orderTypeData},SELECTED_STATE=${cartDetails.shipToSiteAddressState},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderType === DVA_ORDER_TYPE ? DVA_ORDER_TYPE : orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=${shipToSiteId},CUSTOMER_SEGMENT=${apQualifier}${orderType !== DVA_ORDER_TYPE ? `,PRICE_LIST_ID=${priceListId}` : ""}` : ''] })
        : getHeader({ functionName: 'shippingInformation.getDefaultShippingForAccount', values: [`ORDER_TYPE=STANDARD,GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=STANDARD,GEOIP_SECOND_LEVEL_DOMAIN=0,CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}`] }),
    });
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getReturnCenterAddress = async (
  isLoader = false,
  shipToIds = '',
  preferredLocale = ''
) => {
  const shippingId = sessionStorage.getItem('shipToIds') || shipToIds;

  try {
    const cachedData = sessionStorage.getItem(RETURN_CENTER_ADDRESS_KEY);

    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      const cachedLocale = (parsedData?.preferredLocale || '')?.replace(/_/g, '-');
      const requestedLocale = (preferredLocale || '')?.replace(/_/g, '-');
       if (cachedLocale === requestedLocale) {
        return parsedData?.data;
      }
    }

    const headers = getHeader({
      functionName: 'shippingInformation.getReturnCenterAddress',
    });

    headers['X-Session-Attributes'] = `CURRENCY=${
      localStorage.getItem('customerDefaultCurrency') || ''
    },LOCALE=${preferredLocale}`;
    
    const newLang = preferredLocale?.replace(/_/g, '-') || getUserLocale();

    const headerParams = {
      headers,
      noLoader: isLoader,
    };

    const response = await axios.get(
      `${config.api.path}/extrelatedaccounts/${localStorage.getItem(
        'StoreName'
      )}/shiptoaccounts/${encode(`${shippingId}||${newLang}`)}?zoom=element`,
      headerParams
    );

    const data = response?.data;

    if (data?.['ship-to-account']?.length > 0) {
      sessionStorage.setItem(
        RETURN_CENTER_ADDRESS_KEY,
        JSON.stringify({
          preferredLocale,
          data,
        })
      );
    }

    return data;
  } catch (err) {
    // err
  }
};

export const getShippingInfoNote = async(userLocale) =>{
  const encodeValue = `PATH=COMMERCE/SYSTEM/ROS/PLACE_ORDER/ShippingInfoNote;CONTEXT=shipping.info.note.enabled;LOCALE=${userLocale}`;
  const headerParams = {
    headers: getHeader({ functionName: 'shippingInformation.getShippingInfoNote' }),
  };
  try {
    const resp = await axios.get(`${config.api.path}/rosutils/${localStorage.getItem('StoreName')}/${encode(encodeValue)}/info`, headerParams);
    return resp;
  } catch (err) {
    throw err.message;
  }

}

export const setDefaultShippingAtLogin = async ( shipAddress, orderType, isDefault = false) => {
  const orderTypeData =  orderType || null;
  const postData = {
    'shipping-address-id': shipAddress.split('/')[3],
    'is-default': isDefault,
  };
  try {
    const resp = await axios.post(`${config.api.path}/rosdefaultaddress/${localStorage.getItem('StoreName')}/form?followlocation`, postData, {
      headers: getHeader({ functionName: 'shippingInformation.setDefaultShippingForAccount', values: [ `ORDER_TYPE=${orderTypeData},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=0,CUSTOMER_SEGMENT=,PRICE_LIST_ID=`] }),
    });
    localStorage.setItem('customerDefaultCurrency', resp.data?.['customer-default-currency'] ? resp.data?.['customer-default-currency'] : '');
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getDefaultShippingForAccountAtLogin = async (orderType) => {
  const orderTypeData = orderType || null;

  try {
    const resp = await axios.get(
      `${config.api.path}/rosdefaultaddress/${localStorage.getItem('StoreName')}/info`,
      {
        headers: getHeader({
          functionName: 'shippingInformation.getDefaultShippingForAccount',
          values: [
            `ORDER_TYPE=${orderTypeData},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${orderTypeData},GEOIP_SECOND_LEVEL_DOMAIN=0,CUSTOMER_SEGMENT=,PRICE_LIST_ID=`,
          ],
        }),
      }
    );

    return resp;
  } catch (err) {
    throw err.message;
  }
};


export default {
  getBillingAddress,
  getShippingAddress,
  getOrderId,
  setDefaultcontactInfo,
  getShippingMethod,
  getShippingNewMethod,
  callSetDefaultShippingMethod,
  getDefaultShippingForAccount,
  setDefaultShippingForAccount,
  getReturnCenterAddress,
  getShippingInfoNote
};
